/**
 * Helper for responsive inline svgs a la
 * <div class="resp-content" data-resp-base="images/" data-resp="image.png:s,480:image-medium.png:m,960:image-big.jpg:l" />
 *
 * data-resp-base: content base path
 * data-resp: comma separated list with $breakpoint:$file:$className
 */
import { debounce } from './utils';

const localCache = {};

function init() {
  updateElements();
  bindEvents();
}

function updateElements() {
  const respContent = document.querySelectorAll('.resp-content');
  [].forEach.call(respContent, updateContent);
}

function bindEvents() {
  const debouncedResize = debounce(updateElements, 100);
  window.addEventListener('resize', debouncedResize);
}

function updateContent(el) {
  const baseUrl = el.getAttribute('data-resp-base');
  const respRules = el.getAttribute('data-resp');

  if (typeof baseUrl !== 'undefined' && typeof respRules !== 'undefined') {
    let currRule;
    const classNames = [].map.call(el.classList, c => c);
    const rules = respRules.split(',').map((rule, i) => {
      rule = i === 0 ? `0:${rule}` : rule;
      const ruleSplitted = rule.split(':');
      return [+ruleSplitted[0], ruleSplitted[1], ruleSplitted[2]]
    }).sort((a, b) => b[0] - a[0]);

    for (let i = 0; i < rules.length; i++) {
      currRule = rules[i];
      if (window.innerWidth > currRule[0]) {
        break;
      }
    }

    const baseClasses = classNames.filter(c => !rules.filter((r) => r[2] === c).length);
    const contentUrl = `${baseUrl}${currRule[1]}`;
    const elClasses = `${baseClasses.join(' ')} ${currRule[2] ? currRule[2] : ''}`;

    updateElementContent(el, contentUrl, elClasses);
  }
}

async function updateElementContent(el, url, classes) {
  let content = localCache[url];

  if (!content) {
    content = await $.get({ url, dataType: 'text' });
  }

  while (el.firstChild) {
    el.removeChild(el.firstChild);
  }

  el.innerHTML = content;
  el.className = classes;

  const childEl = el.firstChild;
  const contentType = childEl.tagName;

  if (contentType && contentType.toLowerCase() === 'svg') {
    const width = childEl.getAttribute('width');
    const height = childEl.getAttribute('height');

    childEl.setAttribute('viewBox', `0 0 ${width} ${height}`);
    childEl.setAttribute('preserverAspectRatio', 'xMinYmin meet');

    childEl.removeAttribute('width');
    childEl.removeAttribute('height');

    const ratio = height / width * 100;
    
    el.style.paddingBottom = `${ratio.toFixed(0)}%`;
  }

  localCache[url] = content;
}

export default {
  init
}